module.exports = __webpack_public_path__ + "img/02_content_04@2x.d2803931.png";